import React from 'react'
import Container from '@material-ui/core/Container';
import imglasoñada from '../../assets/galerials3.jpg';
import imgHero from '../../assets/imghero2.jpg';
import lasoñada from '../../assets/lasoñada.svg';
import namaste from '../../assets/namaste.svg';
import BotonBox from '../BotonBox';


const Section5 = () => {
  return (
    <div id='rel' className='section noPadBot indexSec'>
        <Container className='relative flex flexCol'>
        <h2 className='textCenter' style={{margin: '30px 0 60px'}}>Ver más proyectos</h2>

        <div className="flex flexRow flexWrap col50 reverse">
            <div className='backDark shadow hoverScale'>
              <img className='logoBox' src={namaste} alt="Logo Namasté" />
              <h3 className='textCenter'>Entre Médanos y Mar</h3>
              <p className='textCenter relative pbox'>Una propuesta única frente al mar y en un marco natural único, con todo el confort de un proyecto pensado para una verdadera inmersión sensorial</p>
              <BotonBox className='hoverScale' text='Ver más' link='/namaste' />
            </div>
            <div>
            <img className='imgProyecto' src={imgHero} alt="Imágen Namasté" />

            </div>
          </div>


          <div className="flex flexRow flexWrap col50 margtop">
            <div className='backDark shadow hoverScale'>
             <img className='logoBox' src={lasoñada} alt="Logo La Soñada" />
              <h3 className='textCenter relative'>La belleza de lo simple</h3>
              <p className='textCenter relative pbox'>Su diseño en forma de "L" permite a la vivienda repararse de los vientos fríos y húmedos y al mismo tiempo abrazar gran cantidad de luz generando frescura y confort a cada uno de sus ambientes</p>

              <BotonBox className='hoverScale' text='Ver más' link='/lasonada' />
            </div>
            <div>
              <img className='imgProyecto' src={imglasoñada} alt="Imágen La Soñada" />
            </div>
          </div>
        </Container>
    </div>
  )
}

export default Section5